// Layout Component Types
export const COMPONENT_TYPES = {
  RACING: 'racing',

  SPORT_PREMATCH: 'sportPrematch',
  SPORT_LIVE: 'sportLive',
  SPORT_ASIAN: 'sportAsian',

  CASINO: 'casino',
  CASINO_LIVE: 'casinoLive',

  RESULTS: 'results',

  MENU: 'menu',
  TV_GAMES: 'tvGames',
  CLIENT_PROFILE: 'clientProfile',
  PROMOTIONS: 'promotions',
  PROMOTION_TOURNAMENTS: 'promotionTournaments',
}

export const CLIENT_PROFILE_COMPONENT_TYPES = {
  PROFILE: 'profile',
  PROFILE_MAIN: 'mainInformation',
  PROFILE_CHANGE_PASSWORD: 'changePassword',
  PROFILE_VERIFY: 'verifyDocuments',

  PAYMENT: 'payment',
  PAYMENT_DEPOSIT: 'deposit',
  PAYMENT_WITHDRAWAL: 'withdrawal',

  HISTORY: 'history',
  HISTORY_BET_HISTORY: 'betHistory',
  HISTORY_MY_ORDERS: 'myOrders',
  HISTORY_TRANSACTION_HISTORY: 'transactionHistory',
  HISTORY_CASINO_HISTORY: 'casinoHistory',

  RESPONSIBLE_GAMING: 'responsibleGaming',
  SELF_REGULATION: 'selfRegulation',
  SELF_EXCLUSION: 'selfExclusion',
  REALITY_CHECK: 'realityCheck',

  BONUSES: 'bonuses',
  SETTINGS: 'settings',

  COMMUNICATION: 'communication'
}
